import {AUTH_REQUEST,AUTH_REQUEST_SUCCESS,AUTH_REQUEST_FAILED, RESET_IS_AUTHORIZED }  from './actionTypes'

export const authRequest = (data) => ({type:AUTH_REQUEST, payload:data})
export const authSuccess = data => ({ type: AUTH_REQUEST_SUCCESS, payload:data})
export const authRequestFailed = () => ({type: AUTH_REQUEST_FAILED})

export const resetIsAuthorized = () => ({type: RESET_IS_AUTHORIZED})

